<div [class]="phaseClass" class="h-screen flex flex-col">
  <app-desktop-header active="health-assistant" (sectionSelect)="onHeaderSectionSelect($event)"></app-desktop-header>

  <!-- Cycle phase row - part of Chat Menu/Desktop in Figma (node 25769:284075) -->
  <div *ngIf="cyclePhase?.state || cyclePhase?.day != null"
    class="hidden md:flex h-[60px] w-full shrink-0 items-center justify-end bg-white px-[132px]">
    <app-cycle-status [cyclePhase]="cyclePhase" variant="header"></app-cycle-status>
  </div>

  <div *ngIf="graphType" class="modal-overlay">
    <div class="modal-content">
      <button class="close-btn" (click)="graphType = null">✖</button>
      <app-wellness-chart [type]="graphType"></app-wellness-chart>
    </div>
  </div>

  <!-- Player overlay -->
  <div *ngIf="showPlayer" class="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
    <div class="relative w-[90%] max-w-3xl bg-black rounded-lg shadow-lg animate-fade-in">

      <button (click)="closePlayer()"
        class="absolute top-2 right-2 text-white hover:bg-black/80 rounded p-2 z-10">✕</button>
      <app-content-player *ngIf="playerSrc" [src]="playerSrc" [image]="playerImage"></app-content-player>
    </div>
  </div>

  <!-- Subscription Modal (auto on day limit) -->
  <div *ngIf="showSubscription" class="fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-50">
    <div
      class="relative w-full overflow-y-auto h-full md:w-[90%] md:h-auto md:max-h-[90dvh] md:max-w-2xl bg-[#F1F1F9] md:rounded-2xl shadow-xl animate-fade-in p-4">
      <button (click)="showSubscription=false"
        class="absolute top-4 right-4 text-gray-700 hover:bg-gray-100 rounded-full p-2 z-10"
        aria-label="Close subscription">
        ✕
      </button>
      <app-subscription [hideHeader]="true" [isVisible]="true" (dismiss)="showSubscription=false"></app-subscription>

    </div>
  </div>

  <app-encryption-blocker [isEncrypted]="isEncrypted" (closed)="isEncrypted = false">
  </app-encryption-blocker>


  @if (showQuickActionsOverlay) {
  <app-quick-actions-overlay [trigger]="triggerQuickActionChange" [userData]="userData"
    [showQuickActions]="selectedQuickAction" (closeQuickAction)="quickActionOverlayTriggerResponse()"
    (addQuickAction)="messageText = $event" (selectedQuickAction)="selectQuickSubAction($event)"
    [selectedOptionTrigger]="triggerSelectedAction"
    class="flex-1 overflow-y-auto px-0 md:px-[180px] lg:px-[240px] xl:px-[300px] 2xl:px-[360px] md:mt-6 no-scrollbar">
  </app-quick-actions-overlay>
  } @else {
  <div
    class="flex justify-between items-center p-6 pb-4 md:px-0 md:px-[180px] lg:px-[240px] xl:px-[300px] 2xl:px-[360px]">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Hi, {{ this.userName ?? userService.user.username ?? 'User' }}</h1>
    </div>
    <button (click)="openMenu()" class="md:hidden p-2 hover:bg-white/20 rounded-lg transition-colors">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 26H17V24H11V26ZM11 14V16H29V14H11ZM11 21H23V19H11V21Z" fill="black" />
      </svg>
    </button>
  </div>

  <div [class.pointer-events-none]="isEncrypted" [class.opacity-30]="isEncrypted"
    class="flex-1 overflow-y-auto px-0 md:px-[180px] lg:px-[240px] xl:px-[300px] 2xl:px-[360px] md:my-6 no-scrollbar"
    (wheel)="onUserScroll($event)" (touchmove)="onUserDrag($event)">
    <div class="px-0 mb-6">
      <app-cycle-status class="md:hidden" [cyclePhase]="cyclePhase"></app-cycle-status>

      <div #chatContainer class="flex-1 overflow-y-auto" [class.pointer-events-none]="showLoader">

        <div *ngIf="showScrollHistoryButton" class="flex justify-center my-4">
          <button (click)="loadMoreMessages()"
            class="px-4 py-2 text-sm rounded-full bg-white hover:bg-gray-50 transition gradient-border" style="
              background:
                linear-gradient(#fff, #fff) padding-box,
                linear-gradient(83.1deg, #81FFE1 18.84%, #B77FD8 56.17%, #B77FD8 100.33%) border-box;
              border: 1px solid transparent;
            ">
            SCROLL HISTORY
          </button>


        </div>

        <ng-container
          *ngFor="let day of (displayedAllMessages$ | async) | keyvalue : dateSort; let total = count; trackBy: trackByDay">
          <ng-container *ngIf="shouldShowDivider(total)">
            <div class="flex items-center my-4">
              <span class="text-sm font-semibold mr-2" style="color: #4C4F53;">
                {{ formatDay(day.key) }}
              </span>
              <div class="flex-1 mx-2" style="border-top: 1px solid #0000001A;"></div>
              <span class="ml-2 text-xl leading-none">⋯</span>
            </div>
          </ng-container>

          <ng-container *ngFor="let message of day.value; trackBy: trackByMessage">
            <div [attr.data-msg-id]="message.id">
              <!-- User input -->
              @if (message.source === 'user'
              && message.message
              && message.message.trim() !== ''
              && !message.message.startsWith('#chatresponse')) {
              <app-user-input-card [data]="message"></app-user-input-card>
              }
              <!-- Assistant -->
              @else if (message.source === 'assistant') {
              @switch (message.answer.card) {
              @case ('C1') { <app-text-card [data]="message"></app-text-card> }
              @case ('C2') {
              <app-multi-input-card [data]="message"
                [class]="{ 'pointer-events-none': message.id !== lastMessageId && message.answer.cta != 'INTRO'}"
                (onMultiSelect)="onMultiselect($event)" (onDeselect)="onDeselectOption($event)"
                [selectedOptions]="multiSelectOptions.options[message.id] ?? []"
                [showOptions]="message.id == lastMessageId || message.answer.cta == 'INTRO'">
              </app-multi-input-card>
              }
              @case ('C3') {
              <app-single-input-card [data]="message"
                [class]="{ 'pointer-events-none': message.id !== lastMessageId && message.answer.cta != 'INTRO'}"
                (onSelect)="onSingleSelect($event)"
                [showOptions]="message.id == lastMessageId || message.answer.cta == 'INTRO'">
              </app-single-input-card>
              }
              @case ('C4') { <app-general-assistant-card
                (onSelect)="onSingleSelect($event)"></app-general-assistant-card>
              }
              @case ('C5') {
              <app-content-card [data]="message" (showContent)="showContent($event)"
                (showMore)="showMoreContent($event)">
              </app-content-card>
              }
              @default { <app-text-card [data]="message"></app-text-card> }
              }
              }
            </div>
          </ng-container>
        </ng-container>



        <app-loader *ngIf="showLoader"></app-loader>
      </div>
    </div>
    <div #bottomMarker></div>
  </div>

  <!-- Quick actions -->
  <div class="ps-4 md:px-[180px] lg:px-[240px] xl:px-[300px] 2xl:px-[360px]">
    <app-quick-actions [actions]="quickActions" (quickMessage)="sendQuickMessage($event)"></app-quick-actions>
  </div>

  }

  <div class="pt-0 md:pt-4 px-0 md:px-[180px] lg:px-[240px] xl:px-[300px] 2xl:px-[360px]">
    @if (dayLimitReached){
    <!-- Premium banner when daily limit reached -->
    <app-try-premium *ngIf="dayLimitReached" (onTryPremiumClick)="showSubscription = true"></app-try-premium>
    } @else {
    <div class="rounded-t-lg md:rounded-2xl shadow-none md:shadow-sm
         border-t md:border md:mb-6
         border-[rgba(227,227,227,1)]" [ngClass]="messageText?.trim().length
    ? 'md:border-2 md:!border-[#5810FF]'
    : ''" style="box-shadow: 0px 4px 4px 0px rgba(227, 215, 255, 1);
         background: rgba(255,255,255,1);">
      <div class="flex items-center p-2 md:p-4">
        <!-- toggle button -->
        <button (click)="toggleQuickActionOverlay(true)"
          class="p-1 md:p-2 hover:bg-gray-100 rounded-full transition-colors mr-2 md:mr-3">
          @if (!showQuickActionsOverlay) {
          <svg class="w-5 h-5 md:w-6 md:h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          } @else {
          <svg class="w-5 h-5 md:w-6 md:h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          }
        </button>

        <input type="text" [(ngModel)]="messageText" [disabled]="showLoader || shouldDisableInput()"
         (keydown.enter)="!isMobile && sendMessage()"
         (keydown.shift.enter)="$event.stopPropagation()"
          placeholder="Select options or start typing..." class="flex-1 h-10 md:h-auto text-sm md:text-base bg-transparent outline-none
                 text-gray-700 placeholder-gray-500 focus:ring-0 focus:outline-none" [ngClass]="messageText?.trim().length
            ? 'border-2 border-[#5810FF] rounded-[10px] focus:!border-[#5810FF] md:!border-0'
            : '!border-0'" />

        <!-- mic -->
        <button (mousedown)="startVoiceRecording()" (mouseup)="stopVoiceRecording()" (mouseleave)="stopVoiceRecording()"
          (touchstart)="startVoiceRecording()" (touchend)="stopVoiceRecording()"
          class="p-1 md:p-2 transition-colors hover:text-[#DDB9FD]">
          <svg class="w-5 h-5 md:w-6 md:h-6"
            [ngClass]="{ 'text-[#DDB9FD] animate-pulse': isRecording, 'text-gray-700': !isRecording }"
            fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm4-3a4 4 0 0 1-8 0H6a6 6 0 0 0 12 0h-2zM11 18h2v3h-2v-3z" />
          </svg>
        </button>

        <!-- send -->
        <button (click)="sendMessage()" [disabled]="!messageText.trim() || showLoader" class="w-8 h-8 md:w-10 md:h-10 bg-gray-900 text-white rounded-full flex items-center justify-center
                 hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ml-1">
          <svg class="w-4 h-4 md:w-5 md:h-5 rotate-45 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        </button>
      </div>
    </div>
    }


  </div>

  <app-desktop-footer></app-desktop-footer>
</div>

<!-- Profile onboarding: blocks sending once the free messages are used and mandatory profile data is missing -->
<app-profile-onboarding
  [open]="showProfileOnboarding"
  [questions]="profileQuestions"
  (answered)="onProfileAnswer($event)"
  (completed)="showProfileOnboarding = false"
  (dismissed)="showProfileOnboarding = false"
></app-profile-onboarding>

<div class="fixed inset-0 z-50" [class.pointer-events-none]="!isMenuOpen">
  <div class="absolute inset-0 bg-black transition-opacity duration-300 ease-out"
    [ngClass]="{ 'opacity-40 pointer-events-auto': isMenuOpen, 'opacity-0 pointer-events-none': !isMenuOpen }"
    (click)="closeMenu()"></div>
  <div class="absolute inset-0 bg-white transform transition-transform duration-300 ease-out"
    [ngClass]="{ 'translate-x-0': isMenuOpen, 'translate-x-full': !isMenuOpen }">
    <div class="h-full overflow-y-auto bg-settings">
      <app-sidemenu (onBackClick)="closeMenu()"></app-sidemenu>
    </div>
  </div>
</div>

<!-- Content Viewer -->
<div class="fixed inset-0 z-[60]" [class.pointer-events-none]="!isContentViewerOpen">
  <div class="absolute inset-0 bg-black transition-opacity duration-300 ease-out"
    [ngClass]="{ 'opacity-40 pointer-events-auto': isContentViewerOpen, 'opacity-0 pointer-events-none': !isContentViewerOpen }"
    (click)="closeContentViewer()"></div>
  <div class="absolute inset-0 bg-white transform transition-transform duration-300 ease-out"
    [ngClass]="{ 'translate-y-0': isContentViewerOpen, 'translate-y-full': !isContentViewerOpen }">
    <app-content-viewer class="w-full h-full block" (close)="closeContentViewer()"
      [url]="weblinkUrl"></app-content-viewer>
  </div>
</div>
